import React from 'react';

function ReloadPrompt() {
  return null;
}

export default ReloadPrompt; 